/**
 * Form for displaying and deleteing an api token.
 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { reduxForm, SubmissionError } from 'redux-form';
import { withStyles } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';

import CopyToClipboard from 'components/CopyToClipboard/CopyToClipboard';
import MoreLessString from './MoreLessString/MoreLessString';

const propTypes = {
  classes: PropTypes.shape({
    field: PropTypes.string.isRequired,
  }).isRequired,
  name: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  className: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  onTokenDelete: PropTypes.func.isRequired,
};

const defaultProps = {
  className: null,
};

export function UnStyledApiTokenItem({
  classes,
  className,
  name,
  token,
  valid,
  handleSubmit,
  onTokenDelete,
}) {
  const handleFormSubmissionReturn = (result) => {
    if (result.error) {
      throw new SubmissionError(result.formErrors);
    }
  };

  const submitHandler = (data) => onTokenDelete(data.id).then(handleFormSubmissionReturn);

  return (
    <form onSubmit={handleSubmit(submitHandler)} className={classnames([className, classes.root])}>
      <div className={classes.root}>
        <div className={classes.col}>
          <Typography variant="subtitle1">{name}</Typography>
          <Typography className={classes.apikey} variant="body2">
            <MoreLessString string={token} />
          </Typography>
        </div>
        <div className={classes.col}>
          <CopyToClipboard
            copyString={token}
            copyStyles={{
              marginTop: '8px',
              backgroundColor: '#3C9BA0',
              color: '#FFF',
            }}
            checkColor="inherit"
            size="small"
          />
        </div>
        <div className={classes.col}>
          <Fab type="submit" size="small" disabled={!valid} classes={{ root: classes.trash }}>
            <Icon>delete</Icon>
          </Fab>
        </div>
      </div>
    </form>
  );
}

UnStyledApiTokenItem.propTypes = propTypes;
UnStyledApiTokenItem.defaultProps = defaultProps;

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  field: {
    marginTop: theme.spacing(2),
  },
  trash: {
    color: theme.customColors.white,
    backgroundColor: theme.customColors.red,
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
    [theme.breakpoints.only('xs')]: {
      marginTop: 0,
      marginLeft: theme.spacing(1),
    },
  },
});

export default withStyles(styles)(
  reduxForm({
    form: 'apiTokenItemDeleteForm',
    field: ['id'],
    destroyOnUnmount: true,
  })(UnStyledApiTokenItem),
);
